import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { stringFilterOperators } from '../../../../containers/base-filter-bar-container/reference-data-criteria-arguments';
import { messages } from '../../messages';

import style from '../common.module.less';

const shouldHideTextBox = (operator) => {
  return operator.id === stringFilterOperators.isBlank || operator.id === stringFilterOperators.isNotBlank;
};

export const FormString = (criterionStateMethods, criterionOperatorOptions) => {
  const selectedOperator = criterionStateMethods.getCriterionOperator();
  const selectedOperatorLabel = selectedOperator ? selectedOperator.displayName : '';
  const selectedArgument = criterionStateMethods.getCriterionArgument();
  const argumentValue = selectedArgument ? selectedArgument.value : [];
  const argumentValueArray = Array.isArray(argumentValue) ? argumentValue : [argumentValue];

  if (shouldHideTextBox(selectedOperator)) {
    return (
      <div className={style['form-criteria-section']}>
        <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
          <DropdownMenuToggler>{selectedOperatorLabel}</DropdownMenuToggler>
          {criterionOperatorOptions.map((option) => (
            <DropdownMenuItem
              key={option.id}
              onClick={() => criterionStateMethods.updateCriterionOperator(option)}
              selected={option.id === selectedOperator.id}
            >
              {option.displayName}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      </div>
    );
  }
  return (
    <div className={style['form-criteria-section']}>
      <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler>{selectedOperatorLabel}</DropdownMenuToggler>
        {criterionOperatorOptions.map((option) => (
          <DropdownMenuItem
            key={option.id}
            onClick={() => criterionStateMethods.updateCriterionOperator(option)}
            selected={option.id === selectedOperator.id}
          >
            {option.displayName}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
      <input
        className={style['free-text-input']}
        onChange={(e) =>
          criterionStateMethods.updateCriterionArgument({
            value: e.target.value.split(';'),
          })
        }
        value={argumentValueArray.join(';')}
      />
      <div className={style['free-text-subheader']}>
        <FormattedMessage {...messages.freeTextSubHeader} />
      </div>
    </div>
  );
};
